export default __webpack_public_path__ + "static/media/6.d48609b2.png";